import { z } from 'zod';
/** Shared pagination contracts — the house pattern for list endpoints and the screens they back. */
/**
 * Query params for a numbered-page list endpoint. `z.coerce` so the API can parse them straight
 * from `req.query` (always strings), while callers building a request pass numbers. The bounds
 * keep one request from asking for an unbounded page.
 */
export const paginationParamsSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
/**
 * Wrap an item schema in the standard list envelope `{ items, total, page, pageSize }`.
 * `total` is the full count across all pages, for "showing X of N" and page controls.
 */
export function paginated(item) {
    return z.object({
        items: z.array(item),
        total: z.number().int().nonnegative(),
        page: z.number().int().min(1),
        pageSize: z.number().int().min(1),
    });
}
//# sourceMappingURL=pagination.js.map